var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _circle2, _circle3, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#ECF4FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 33V26.9997C58 23.1665 56.6253 19.8751 53.8752 17.1251C51.1252 14.375 47.8341 13 44.0002 13C40.1664 13 36.8746 14.375 34.1248 17.125C31.3747 19.8751 30 23.1664 30 26.9997V33H58ZM52.0002 33H36.0001V26.9997C36.0001 24.7915 36.7815 22.906 38.344 21.3438C39.9067 19.7813 41.792 19.0003 44.0005 19.0003C46.2092 19.0003 48.094 19.7812 49.6568 21.3438C51.2189 22.9059 52.0002 24.7915 52.0002 26.9997V33Z",
    fill: "#0A5EC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 33V26.9997C58 23.1665 56.6253 19.8751 53.8752 17.1251C51.1252 14.375 47.8341 13 44.0002 13C40.1664 13 36.8746 14.375 34.1248 17.125C31.3747 19.8751 30 23.1664 30 26.9997V33H58ZM54.0002 32H34.0001V25.9997C34.0001 23.7915 35.5 20.8945 37.344 19.3438C38.9067 17.7813 41.7917 16.8945 44.0002 16.8945C46.2089 16.8945 49.094 17.7812 50.6568 19.3438C52.5 20.8945 54.0002 23.7915 54.0002 25.9997V32Z",
    fill: "#3C88E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0001 13.8945C46.6843 13.8945 49.04 14.5545 51.0682 15.8745C51.574 16.2037 51.5992 16.9152 51.1557 17.3243C50.7997 17.6526 50.2604 17.6686 49.8555 17.403C48.5309 16.5342 46.5336 15.6792 44.0004 15.6792C41.4731 15.6792 39.6494 16.5302 38.3799 17.397C37.9742 17.6739 37.4334 17.6792 37.0481 17.3745C36.5128 16.9511 36.512 16.1366 37.0898 15.7733C39.0821 14.5208 41.3855 13.8945 44.0001 13.8945Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24.8945L58 26.8945V29.8945H52V24.8945Z",
    fill: "#0A5EC0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 24.8945L30 26.8945V29.8945H36V24.8945Z",
    fill: "#0A5EC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44 26.0156L24.2081 31.4324C22.9042 31.7893 22 32.9741 22 34.326V42.6158C22 56.2055 30.4187 68.4447 43.4134 73.7904L44 74.0156L44.5866 73.7904C57.5813 68.4447 66 56.2055 66 42.6158V34.326C66 32.9741 65.0958 31.7893 63.7919 31.4324L44 26.0156Z",
    fill: "#3C88E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5866 73.7904L44 74.0156V26.0156L63.7919 31.4324C65.0958 31.7893 66 32.9741 66 34.326V42.6158C66 56.2055 57.5813 68.4447 44.5866 73.7904Z",
    fill: "#0A5EC0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30.8945L28.3078 34.6157C26.9551 34.9365 26 36.1446 26 37.5348V43.4197C26 55.3106 32.2707 65.02 43.4934 69.6975L44 69.8945L44.5066 69.6975C55.7293 65.02 62 55.3106 62 43.4197V37.5348C62 36.1446 61.0449 34.9365 59.6922 34.6157L44 30.8945Z",
    fill: "#9EC9FA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5066 69.6975L44 69.8945V30.8945L59.6922 34.6157C61.0449 34.9365 62 36.1446 62 37.5348V43.4197C62 55.3106 55.7293 65.02 44.5066 69.6975Z",
    fill: "#7DB4F2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 46.0352,
    width: 4,
    height: 10,
    rx: 2,
    fill: "#0A5EC0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 43.5781,
    r: 5,
    fill: "#0A5EC0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 13,
    fill: "#017E39",
    stroke: "#ECF4FE",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M55.75 62.6075L59.6269 66.4845L67.9346 58.1768",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeIcon);
export default __webpack_public_path__ + "static/media/BadgeIcon.f2e80b34c3cfb266ad3ac36d6344ea69.svg";
export { ForwardRef as ReactComponent };